import { useEffect, useState } from 'react';
import api from '../../api/axios';
import MasterEditModal from '../../components/MasterEditModal';

export default function Models() {
  const [rows, setRows] = useState([]);
  const [name, setName] = useState('');
  const [editRow, setEditRow] = useState(null);
  const [editForm, setEditForm] = useState({ name: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const load = () => {
    api.get('/models').then((r) => setRows(r.data));
  };

  useEffect(() => {
    load();
  }, []);

  const add = async () => {
    if (!name.trim()) return;
    setError('');
    try {
      await api.post('/models', { name, category_id: null, body_style: null });
      setName('');
      load();
    } catch (err) {
      setError(err?.response?.data?.message || err.userMessage || 'تعذر إضافة الموديل. تحقق من البيانات ثم حاول مرة أخرى.');
    }
  };

  const openEdit = (row) => {
    setEditRow(row);
    setEditForm({ name: row.name || '' });
  };

  const update = async () => {
    if (!editForm.name.trim() || !editRow) return;
    setSaving(true);
    setError('');
    try {
      await api.put(`/models/${editRow.id}`, { name: editForm.name, category_id: null, body_style: null });
      setEditRow(null);
      load();
    } catch (err) {
      setError(err?.response?.data?.message || err.userMessage || 'تعذر حفظ تعديل الموديل.');
    } finally {
      setSaving(false);
    }
  };

  const remove = async (row) => {
    if (!window.confirm('تأكيد الحذف؟')) return;
    await api.delete(`/models/${row.id}`);
    load();
  };

  return (
    <div>
      <div className="grid md:grid-cols-2 gap-2 mb-3">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="rounded-lg border p-2"
          placeholder="اسم الموديل"
        />
        <button onClick={add} className="rounded-lg bg-primary px-3 py-2 text-white">إضافة</button>
      </div>
      {error && (
        <div className="mb-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </div>
      )}
      <table className="w-full text-sm border rounded-lg overflow-hidden">
        <thead className="bg-slate-100">
          <tr>
            <th className="p-2 text-right">الاسم</th>
            <th className="p-2">إجراءات</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t">
              <td className="p-2">{r.name}</td>
              <td className="p-2 flex gap-2 justify-center">
                <button onClick={() => openEdit(r)} className="px-2 py-1 border rounded">تعديل</button>
                <button onClick={() => remove(r)} className="px-2 py-1 border rounded text-red-600">حذف</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <MasterEditModal
        open={Boolean(editRow)}
        title="تعديل الموديل"
        subtitle="عدّل اسم الموديل ثم احفظ التغيير."
        fields={[{ name: 'name', label: 'اسم الموديل', required: true, fullWidth: true }]}
        values={editForm}
        onChange={(key, value) => setEditForm((current) => ({ ...current, [key]: value }))}
        onClose={() => setEditRow(null)}
        onSubmit={update}
        saving={saving}
      />
    </div>
  );
}
